import { Component, Input } from '@angular/core';
import { Guard } from '../../models/guard.model';
import { DataFormModel } from '../../models/data-form-model.model';
import { FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppGuardService } from '../../services/app-guard.service';
import { GateService } from '../../services/gate.service';
import { NeighborhoodService } from '../../services/neighborhood.service';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-guard-modal',
  templateUrl: './guard-modal.component.html',
  styleUrl: './guard-modal.component.scss'
})
export class GuardModalComponent {

  @Input() guard?: Guard;

  public dataForm: DataFormModel = {
    names: {
      value: '',
      type: 'text',
      label: 'Nombre(s)',
      placeholder: 'Ingrese el nombre del vigilante',
      requiredMessage: 'Por favor, ingrese el nombre del vigilante',
      required: true,
      validators: [Validators.required]
    },
    paternalLastName: {
      value: '',
      type: 'text',
      label: 'Apellido paterno',
      placeholder: 'Ingrese el apellido paterno del vigilante',
      requiredMessage: 'Por favor, ingrese el apellido paterno del vigilante',
      required: true,
      validators: [Validators.required]
    },
    maternalLastName: {
      value: '',
      type: 'text',
      label: 'Apellido materno',
      placeholder: 'Ingrese el apellido materno del vigilante (Opcional)',
      required: false,
      validators: []
    },
    gateId: {
      value: null,
      type: 'select',
      idSelect: 'gateId',
      labelSelect: 'gateName',
      data: [],
      label: 'Acceso',
      placeholder: 'Seleccione a que acceso pertenece (Opcional)',
      required: false,
    },
    digitalLogModule: {
      value: true,
      type: 'switch',
      label: 'Módulo de bitácora digital',
      requiredMessage: '',
      required: false,
      validators: []
    },
    bookingsModule: {
      value: false,
      type: 'switch',
      label: 'Módulo de reservas',
      required: false,
    },
    aiModuleVisits: {
      value: false,
      type: 'switch',
      label: 'Módulo de IA para visitas',
      required: false,
    }
  };

  public formGuard!: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public guardService: AppGuardService,
    public gateService: GateService,
    public neighborhoodService: NeighborhoodService,
    public utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  get f() {
    return this.formGuard.controls;
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR loadData                              */
  /* -------------------------------------------------------------------------- */
  // region loadData
  async loadData() {
    this.loading = true;

    await this.gateService.getAll(
      this.guard!.neighborhoodId
    );

    console.log(this.gateService.gates);
    

    this.dataForm['gateId'].data = this.gateService.gates;

    if (this.guard) {
      this.dataForm = {
        ...this.dataForm
      };

      for (let key of Object.keys(this.dataForm)) {
        if (key in this.guard!) {
          const standardKey = key as keyof typeof this.guard;
          this.dataForm[key].value = this.guard[standardKey]!;
        }
      }

      if (this.guard.guard) {
        this.dataForm['names'].value = this.guard.guard.names;
        this.dataForm['paternalLastName'].value = this.guard.guard.paternalLastName;
        this.dataForm['maternalLastName'].value = this.guard.guard.maternalLastName;
      }
    }

    if (
      !this.neighborhoodService.currentNeighborhood ||
      this.neighborhoodService.currentNeighborhood.neighborhoodId !== this.guard!.neighborhoodId ||
      !this.neighborhoodService.currentNeighborhood.aiModuleVisits
    ) {
      delete this.dataForm['aiModuleVisits'];
    }

    this.formGuard = this.utilService.buildForm(this.dataForm);
    this.loading = false;
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR onSubmit                              */
  /* -------------------------------------------------------------------------- */
  // region onSubmit
  async onSubmit() {
    this.submitted = true;

    if (this.formGuard.invalid) {
      return;
    }

    this.formGuard.value.neighborhoodId = this.guard!.neighborhoodId;

    console.log(this.formGuard.value);
    

    const flag = await this.guardService.update(
      this.formGuard.value,
      this.guard!.guard!
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }

      this.activeModal.close();
    }
  }

}
